import React from "react";
import "../../App.css";

const Services = () => {
  return <h1 className="services">SERVICES</h1>;
};

export default Services;
